// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fVwO","content":"styles_content__2FTzN"};